import { emailKey } from './email-api';
import type { Kind, TemplateDef, AutomationDef } from './email-resources-api';
const prefix = () => `resonance.email-working-copy:${emailKey().join(':')}:`;
export type WorkingCopy = { name: string; definition: TemplateDef | AutomationDef; updatedAt: number };
export function readEmailWorkingCopy(kind: Kind, id = 'new'): WorkingCopy | undefined {
  try {
    const raw = sessionStorage.getItem(`${prefix()}${kind}:${id}`);
    if (!raw) return undefined;
    const value = JSON.parse(raw) as WorkingCopy;
    if (Date.now() - value.updatedAt > 24 * 60 * 60 * 1000 || typeof value.name !== 'string' || !value.definition?.contextObjectId) return undefined;
    return value;
  } catch { return undefined; }
}
export function saveEmailWorkingCopy(kind: Kind, id: string | undefined, copy: Omit<WorkingCopy, 'updatedAt'> | null) {
  try {
    const key = `${prefix()}${kind}:${id ?? 'new'}`;
    if (copy) sessionStorage.setItem(key, JSON.stringify({ ...copy, updatedAt: Date.now() }));
    else sessionStorage.removeItem(key);
  } catch { /* Editing remains available when browser storage is unavailable. */ }
}
export function rememberEmailReturn() {
  if (!/^\/app\/email\/(templates|automations)(\/[^/]+)?$/.test(window.location.pathname)) return;
  try { sessionStorage.setItem(`${prefix()}return`, window.location.pathname); } catch { /* Optional navigation continuity. */ }
}
export function consumeEmailReturn(): string | null {
  if (!new URLSearchParams(window.location.search).has('gmail')) return null;
  try {
    const key = `${prefix()}return`, path = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    return path && /^\/app\/email\/(templates|automations)(\/[a-zA-Z0-9-]+)?$/.test(path) && path !== window.location.pathname ? path : null;
  } catch { return null; }
}
